export default {
  getVenueForEventTemplate(venues, eventTemplate) {
    return venues.find((venue) => venue.id === eventTemplate.venue_id)
  },
}
